import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { Text } from "../../shared/uiComponents";
import { Header } from "../../components/StyledComponents";
import SearchBar from "../../components/SearchBar";
import { AdminTypes } from "../../components/Menu";

import { DispatchProperties, useSelector } from "../../redux/store";
import { clearFilterData } from "../../redux/State/clientSlice/billingSlice";

const SoapNotesHeader = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch<DispatchProperties>();

  const role = useSelector((state) => state.account.role);

  const navigateToSoapNotes = () => {
    dispatch(clearFilterData());
    navigate("/soap-notes");
  };

  const navigateToPendingApproval = () => {
    dispatch(clearFilterData());
    navigate("/soap-notes/dsu");
  };

  return (
    <Header className="padding8">
      <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
        <Text
          title={"SOAP Notes"}
          size="mediumBold"
          onClick={navigateToSoapNotes}
          className={`padding8 ${!pathname.includes("dsu") ? "title" : ""}`}
        />
        {role?.section.id === AdminTypes.admin && (
          <Text
            title={"DSU SOAP Notes"}
            size="mediumBold"
            onClick={navigateToPendingApproval}
            className={`padding8 ${!!pathname.includes("dsu") ? "title" : ""}`}
          />
        )}
      </div>
      <Header>
        <SearchBar />
      </Header>
    </Header>
  );
};

export default SoapNotesHeader;
